import { useCallback } from 'react';
import { Appointment } from '../types/booking';
import { downloadICSFile } from '../utils/calendar';

interface UseCalendarDownloadProps {
	appointmentData: Appointment | null;
	getLabel: (key: string) => string;
	gtmEventDownloadICS: () => void;
}

export function useICSExport({ appointmentData, getLabel, gtmEventDownloadICS }: UseCalendarDownloadProps) {
	const downloadCalendarEvent = useCallback(() => {
		if (!appointmentData) {
			console.error('Cannot download calendar event: appointment data is missing');
			return;
		}

		const description = [`${getLabel('appointment_info_host')}: ${appointmentData.hostName}`].join('\n');

		downloadICSFile({
			bookingServiceName: appointmentData.bookingServiceName,
			description,
			organizerEmail: appointmentData.hostEmail,
			organizerName: appointmentData.hostName,
			attendees: appointmentData.attendees,
			startDate: new Date(appointmentData.startDatetime),
			endDate: new Date(appointmentData.endDatetime),
			location: appointmentData.joinWebUrl,
		});
	}, [appointmentData, getLabel]);

	const handleICSDownload = useCallback(() => {
		gtmEventDownloadICS();
		downloadCalendarEvent();
	}, [gtmEventDownloadICS, downloadCalendarEvent]);

	return { handleICSDownload };
}
